import Vue from 'vue';

function formatarEndereco(rua, numero, bairro, cidade, provincia, pais, codigoPostal) {
  const partes = [];

  if (rua && bairro) {
    const num = numero || 'S/N';
    partes.push(`Rua ${rua}, nº ${num}, ${bairro}`);
  }

  if (cidade || provincia) {
    partes.push([cidade, provincia].filter(Boolean).join(', '));
  }

  if (pais && pais.id) {
    partes.push(`${pais.nome} (${pais.sigla})`);
  }

  let endereco = partes.join(' - ');

  if (codigoPostal) {
    endereco += `${endereco ? ' - ' : ''}${codigoPostal}`;
  }

  return endereco;
}

export function computeEndereco(enderecoObj) {
  if (!enderecoObj) return '';

  const { estado, municipio } = enderecoObj;

  if (estado && municipio && estado.id && municipio.id) {
    return Vue.filter('endereco')(enderecoObj);
  }

  const {
    rua,
    numero,
    bairro,
    cidade,
    provincia,
    pais,
    codigoPostal,
  } = enderecoObj;
  return formatarEndereco(rua, numero, bairro, cidade, provincia, pais, codigoPostal);
}

export default {
  computeEndereco,
};
